import { useMemo } from 'react';

import {
  DROP_ITEM_SIZE,
  ViewProps,
} from '../settings/interactive-response.constants';
import InteractiveDragDisplay from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-display';
import {
  InteractiveResponseViewScaler,
  InteractiveResponseTitle,
} from '../../shared/interactive-response-shared';
import { initialise } from './interactive-response-sequence.utils';
import InteractiveSequenceDropDisplay from './interactive-sequence-drop-display';
import * as Styled from './interactive-response-sequence.style';

const InteractiveResponseSequenceSuggestedAnswer = ({
  properties,
}: ViewProps) => {
  const { dragItems, dropItems } = useMemo(() => {
    return initialise(
      properties.interactiveResponse.variant,
      properties.interactiveResponse.items,
      false
    );
  }, [
    properties.interactiveResponse.variant,
    properties.interactiveResponse.items,
  ]);

  return (
    <InteractiveResponseViewScaler>
      <InteractiveResponseTitle
        title={properties.interactiveResponse.title}
        subTitle={properties.interactiveResponse.subTitle}
      />
      <Styled.InteractiveResponsePreviewDropItemContainer>
        {dragItems.map((item, index) => (
          <InteractiveSequenceDropDisplay
            key={item.id}
            label={dropItems[index].label}
            labelLength={properties.interactiveResponse.labelLength}
            labelBorder={properties.interactiveResponse.labelBorder}
          >
            <InteractiveDragDisplay
              scaleTo={DROP_ITEM_SIZE}
              imageUrl={item.question.image?.small}
              isFit={item.question.image?.isFit}
              description={item.question.image?.description || ''}
              baseColour={item.question.baseColour}
              variant={item.question.variant}
              text={item.question.text}
              richtext={item.question.richtext}
            />
          </InteractiveSequenceDropDisplay>
        ))}
      </Styled.InteractiveResponsePreviewDropItemContainer>
    </InteractiveResponseViewScaler>
  );
};

export default InteractiveResponseSequenceSuggestedAnswer;
